module.exports = __webpack_public_path__ + "img/email.04aa466f.svg";